/* ============
 * Video Popup Store
 * ============
 */

import { defineStore } from 'pinia';
import './pinia';

export const useVideoPopupStore = defineStore('videoPopup', {
  state: () => ({
    visibility: false,
    link: '',
    params: {},
    videoName: '',
    close_name: null,
  }),

  actions: {
    open(data) {
      if (data.close_name && sessionStorage.getItem(data.close_name)) {
        return;
      }
      this.visibility = true;
      this.videoName = data.videoName;
      if (data.link) {
        this.link = data.link;
      }

      if (data.close_name) {
        this.close_name = data.close_name;
      } else {
        this.close_name = null;
      }

      if (data.params) {
        this.params = data.params;
      } else {
        this.params = {};
      }
    },

    close(data) {
      this.visibility = false;
      if (this.close_name && data && data.manually) {
        sessionStorage.setItem(this.close_name, true);
      }
    },
  },
});

export default useVideoPopupStore;
